import cx from 'classnames'
import { FC } from 'react'

import Heading from '@/components/Heading'
import '@/components/Layout/Footer/Molecules/FooterGenreLinks/FooterGenreLinks.scss'
import SlidingTextLink, { SlidingTextLinkProps } from '@/components/Layout/HeaderFooterCommon/Atoms/SlidingTextLink'

type Props = {
  items: readonly SlidingTextLinkProps[]
  headingText: string
  className?: string
}

const FooterGenreLinks: FC<Props> = ({ items, headingText = [], className }) => {
  return (
    <section
      className={cx('c-footer-genreLinks', {
        [className as string]: className,
      })}
    >
      <Heading className="c-footer-genreLinks__heading" headingType="h4" fontSize="1.6rem" fontFamily="Goldenbook">
        {headingText}
      </Heading>
      <ul className="l-footer-genreLinks">
        {items.map((item, i) => (
          <SlidingTextLink key={`${item.text}-${i}`} href={item.href} text={item.text} className="u-font-neue" />
        ))}
      </ul>
    </section>
  )
}

export default FooterGenreLinks
